var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shop-form" },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.formData,
            "label-width": "120px",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-type-selector" },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "el-radio-button",
                    { attrs: { name: "basic", label: "basic" } },
                    [_vm._v("基本信息配置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-button",
                    { attrs: { name: "business", label: "business" } },
                    [_vm._v("业务配置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-button",
                    { attrs: { name: "takeout", label: "takeout" } },
                    [_vm._v("自提外卖")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-button",
                    { attrs: { name: "deliveryArea", label: "deliveryArea" } },
                    [_vm._v("配送范围")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-button",
                    { attrs: { name: "notice", label: "notice" } },
                    [_vm._v("营业公告")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-button",
                    { attrs: { name: "community", label: "community" } },
                    [_vm._v("社区")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-cards" },
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "basic",
                      expression: "activeTab === 'basic'",
                    },
                  ],
                  staticClass: "form-card",
                  attrs: { shadow: "hover" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-info" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("基本信息配置")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-content" },
                    [
                      _c("basic-info", {
                        attrs: {
                          "form-data": _vm.formData,
                          "region-options": _vm.regionOptions,
                          "city-options": _vm.cityOptions,
                          "supplier-options": _vm.supplierOptions,
                          "area-options": _vm.areaOptions,
                        },
                        on: {
                          "preview-image": _vm.handlePictureCardPreview,
                          "update:formData": _vm.handleCommunityFormUpdate,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "business",
                      expression: "activeTab === 'business'",
                    },
                  ],
                  staticClass: "form-card",
                  attrs: { shadow: "hover" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-setting" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("业务配置")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-content" },
                    [
                      _c("business-config", {
                        attrs: {
                          "form-data": _vm.formData,
                          invoiceCompanyOptions: _vm.invoiceCompanyOptions,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "takeout",
                      expression: "activeTab === 'takeout'",
                    },
                  ],
                  staticClass: "form-card",
                  attrs: { shadow: "hover" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-truck" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("自提外卖")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-content" },
                    [
                      _c("takeout-config", {
                        attrs: { "form-data": _vm.formData },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "deliveryArea",
                      expression: "activeTab === 'deliveryArea'",
                    },
                  ],
                  staticClass: "form-card",
                  attrs: { shadow: "hover" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-location" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("配送范围")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-content" },
                    [
                      _c("delivery-area", {
                        attrs: {
                          markers: _vm.formData.markers,
                          area: _vm.formData.area,
                          circle: _vm.formData.circle,
                          "store-lat": _vm.formData.lat,
                          "store-lng": _vm.formData.lng,
                          "store-name": _vm.formData.storeName,
                        },
                        on: { "draw-data-change": _vm.handleDrawDataChange },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "notice",
                      expression: "activeTab === 'notice'",
                    },
                  ],
                  staticClass: "form-card",
                  attrs: { shadow: "hover" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-bell" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("营业公告")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-content" },
                    [
                      _c("business-notice", {
                        attrs: { "form-data": _vm.formData },
                        on: { "notice-change": _vm.handleCommunityFormUpdate },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "community",
                      expression: "activeTab === 'community'",
                    },
                  ],
                  staticClass: "form-card",
                  attrs: { shadow: "hover" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-office-building" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("社区")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-content" },
                    [
                      _c("community-form", {
                        attrs: { "form-data": _vm.formData },
                        on: {
                          "update:formData": _vm.handleCommunityFormUpdate,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-footer-wrapper",
                  staticStyle: { width: "100%", "text-align": "right" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-footer" },
                    [
                      _c("el-button", { on: { click: _vm.handleCancel } }, [
                        _vm._v("取消"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "confirm-button",
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("确认")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "图片预览",
            center: "",
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: {
              "max-width": "100%",
              "max-height": "60vh",
              display: "block",
              margin: "0 auto",
            },
            attrs: { src: _vm.dialogImageUrl },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }